import React from 'react';

function formatDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString();
}

function statusLabel(status) {
  if (!status) return 'Not submitted';
  return status.charAt(0).toUpperCase() + status.slice(1).replace(/-/g, ' ');
}

function typeLabel(complianceType) {
  if (complianceType === 'verified-seller') return 'Verified Seller identity';
  if (complianceType === '2257') return '2257 compliance';
  return complianceType;
}

export default function VerificationRecordList({ payoutProfile, records = [] }) {
  if (!payoutProfile?.exists && records.length === 0) return null;

  return (
    <section className="verification-records" aria-labelledby="verification-records-title">
      <h3 id="verification-records-title">Verification records</h3>
      <ul>
        {payoutProfile?.exists && (
          <li className="verification-record">
            <div>
              <strong>Payout profile</strong>
              <span>{payoutProfile.payoutCountry || 'Country not set'}</span>
            </div>
            <div className="verification-record__status">
              <span>{statusLabel(payoutProfile.status)}</span>
              {formatDate(payoutProfile.submittedAt) && (
                <small>Submitted {formatDate(payoutProfile.submittedAt)}</small>
              )}
            </div>
          </li>
        )}

        {records.map(record => (
          <li className="verification-record" key={record.uuid}>
            <div>
              <strong>{typeLabel(record.complianceType)}</strong>
              <span>{record.legalName || 'Legal name not provided'}</span>
              {record.dba && <small>DBA: {record.dba}</small>}
              {record.complianceType === '2257' && (
                <a href="/account/compliance">Manage 2257 compliance</a>
              )}
            </div>
            <div className="verification-record__status">
              <span>{statusLabel(record.status)}</span>
              {formatDate(record.submittedAt) && (
                <small>Submitted {formatDate(record.submittedAt)}</small>
              )}
              {(record.hasGovId || record.hasSelfie) && (
                <small>Identity images on file</small>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
